import useSharedImagesPath from "@Images/hooks/useSharedImagesPath";
import usePassengers from "@Hooks/selector/usePassengers";

export default function useGetGbtVehicleImage() {
    const imagePath = useSharedImagesPath("images/banner")
    const {passengers = 1} = usePassengers()

    const getImage = (vehicle: GbtVehicleSnippetType) => {
        const images = {
            [`${passengers >= 9}`]: 'peopleCarrier.png',
            [`${passengers >= 4 && passengers < 9}`]: 'minibus.png',
            [`${passengers <= 3}`]: 'standard.png',
        }

        if (vehicle.vehicleGroupName === "Luxury") {
            return `${imagePath}/luxury.png`
        }

        return `${imagePath}/${images.true}`
    }

    return {
        getImage,
    }
}